import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/HomeSection.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/AboutSection.vue')
  },
  {
    path: '/services',
    name: 'Services',
    component: () => import('../views/ServicesSection.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/ContactSection.vue')
  },
  {
    path: '/syndi-cart',
    name: 'SyndiCart',
    component: () => import('../views/SyndiCartSection.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router 